// extracted by css-extract-rspack-plugin
export default {"field":"field___HWVHms__","field__label":"field__label___g5xTKhUC"};